import React, { Component } from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import LabelSelect from '../../common/label/selection.component.jsx'
import Icon from "../../common/icon/icon.component.jsx"

class SubSectionEditForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.subSection = this.props.subSection

        this.state = {
            sectionName: this.subSection.attributes.name,
            sectionDescription: this.subSection.attributes.description,
            labelIds: this.subSection.attributes.labelIds
        }
        const defaultCallback = () => {}
        this.onChange = this.props.onChange || defaultCallback
        this.onDelete = this.props.onDelete || defaultCallback
        this.handleLabelIdsChange = this.handleLabelIdsChange.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this)
        this.deleteSubSection = this.deleteSubSection.bind(this)
    }

    componentDidMount() {}

    handleNameChange(event) {
        const value = event.target.value;
        this.subSection.attributes.name = value
        this.setState({
            sectionName: value
        }, () => {
            this.onChange(this.subSection)
        })
    }

    handleDescriptionChange(event) {
        const value = event.target.value;
        this.subSection.attributes.description = value
        this.setState({
            sectionDescription: value
        }, () => {
            this.onChange(this.subSection)
        })
    }

    handleLabelIdsChange(labelIds) {
        this.subSection.attributes.labelIds = labelIds
        this.setState({
            labelIds: labelIds
        }, () => {
            this.onChange(this.subSection)
        })
    }

    deleteSubSection(event) {
        event.preventDefault()
        this.onDelete(this.subSection)
    }

    render() {
        const subSection = this.subSection
        return <div className="form-group row">
            <div className="col-1" style={{
                textAlign: 'center',
                verticalAlign: 'middle',
                display: 'inline-block',
                lineHeight: '55px',
            }}>
                <Icon value={"caret-right"}/>
            </div>
            <div className="col-4">
                <input
                    name={'name-' + subSection.id}
                    value={this.state.sectionName}
                    onChange={this.handleNameChange}
                    type="text"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                        id: 'guided_selling.form.edit.sub_section_name_placeholder',
                        defaultMessage: 'Name of the sub section',
                    })}
                />
                <small className="form-text text-muted">
                    <FormattedMessage
                        id="guided_selling.form.edit.sub_section_name_description"
                        defaultMessage="The name will show on each quote using this section"
                    />
                </small>
            </div>
            <div className="col-6">
                <LabelSelect
                    name={'labelIds-' + subSection.id}
                    value={this.state.labelIds}
                    onChange={this.handleLabelIdsChange}
                    multi={true}
                />
                <small className="form-text text-muted">
                    <FormattedMessage
                        id="guided_selling.form.edit.section_label_ids_description"
                        defaultMessage="Select labels that will filter the section search"
                    />
                </small>
            </div>
            <div className="col-1 text-align-right">
                <button className="btn btn-danger btn-sm"
                        onClick={this.deleteSubSection}>
                    <Icon value={"trash"}/>
                </button>
            </div>
            <div className="col-1" />
            <div className="col-11">
                <input
                    name={'description-' + subSection.id}
                    value={this.state.sectionDescription}
                    onChange={this.handleDescriptionChange}
                    type="text"
                    className="form-control"
                    placeholder={this.props.intl.formatMessage({
                        id: 'guided_selling.form.edit.sub_section_description_placeholder',
                        defaultMessage: 'Description of the section',
                    })}
                />
                <small className="form-text text-muted">
                    <FormattedMessage
                        id="guided_selling.form.edit.section_description_description"
                        defaultMessage="The description will show on each quote using this model"
                    />
                </small>
            </div>
        </div>
    }
}

export default injectIntl(SubSectionEditForm)


// WEBPACK FOOTER //
// ./src/guided-selling/form/subsection.component.jsx